import { render } from "./Home.vue?vue&type=template&id=60f4b83d&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=60f4b83d&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f4b83d"]])

export default __exports__